import React, { useState } from "react";
import AddParticipant from "../../library/AddParticipant/AddParticipant";
import {
  addParticipantReducer,
  mapDispatchToProps,
} from "./AddParticipant.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { connect } from "react-redux";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import { attachReducer } from "@redux-dynostore/redux-subspace";

export const SmartAddParticipant = (props) => {
  const { addParticipant, onClose, studyId, siteId } = props;

  const [hasError, setHasError] = useState(false);

  const onSubmit = (formData) => {
    setHasError(false);

    addParticipant(formData)
      .then((obj) => {
        sendNotification(obj.message, ToastType.SUCCESS);
        onClose();
      })
      .catch((error) => {
        setHasError(true);
        sendNotification(error, ToastType.ERROR);
      });
  };

  return (
    <AddParticipant
      {...{ onSubmit }}
      {...{ studyId }}
      {...{ siteId }}
      {...{ hasError }}
    />
  );
};

export default dynamic(
  "AddParticipantReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(addParticipantReducer)
)(connect(null, mapDispatchToProps)(SmartAddParticipant));
